import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import system from './reducers/system';
import auth from './reducers/auth';
import users from './reducers/users';
import payments from './reducers/payments';
import media from './reducers/media';
import projects from './reducers/projects';
import companies from './reducers/companies';

//tell redux to match the following properties to each reducer
const rootReducer = combineReducers({
    
    auth,
    users,
    payments,
    media,
    projects,
    companies,
    system,
  
})
  
const store = createStore(rootReducer, applyMiddleware(thunk));;
export default store